import React, { useEffect, useState } from "react";
import {
  GetEmployeedetails,
  insertPerEmployee,
  InsertNominibulk,
  getEmployeeNominees,
  RemoveNominee,
} from "../../services/dataService";
import toast from "react-hot-toast";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { getSecureItem } from "../../services/SecureStorage";

function PersonalDetails({ EmpId, onClose }) {
  const UID = getSecureItem("userId");
  const [isEdit, setIsEdit] = useState(true);
  const [percentageError, setPercentageError] = useState("");

  // State for non-nominee personal details
  const [personalDetails, setPersonalDetails] = useState({
    CurrentAddress: "",
    PermanentAddress: "",
    Experience: "",
    BloodGrp: "",
    PFNo: "",
    FatherorHus: "",
    Qualification: "",
    OtherQualification: "",
    UAN: "",
    PAN: "",
    Nationality: "",
    Religion: "",
    Caste: "",
    OtherCast: "",
    OtherReligion: "",
    openingAmount:"",
    PfOpeningDate:"",
    UserId: UID,
    EmpId: EmpId,


  });

  // State for nominee details
  const [nominees, setNominees] = useState([
    {
      Id: "",
      NomineeName: "",
      NomineeAge: "",
      NomineeAadhar: "",
      Relationship: "",
      OtherRelationship: "",
      NomiNeeAddress: "",
      Percentage: "",
      EmpId: EmpId,
      UserId: UID,
    },
  ]);

  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});

  const handleInputChanges = (e, index = null) => {
    const { name, value } = e.target;
    if (index !== null) {
      // Handle nominee fields
      setNominees((prev) => {
        const updatedNominees = [...prev];
        updatedNominees[index] = {
          ...updatedNominees[index],
          [name]: value,
          EmpId: EmpId,
          UserId: UID,
        };
        return updatedNominees;
      });
      setErrors((prev) => ({
        ...prev,
        [`${name}_${index}`]: validateInput(name, value),
      }));
    } else {
      // Handle non-nominee fields
      setErrors((prev) => ({ ...prev, [name]: validateInput(name, value) }));
      setPersonalDetails((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  useEffect(() => {
    const fetchNominees = async () => {
      const data = {
        EmpId: EmpId,
        UserId: UID,
      };

      try {
        const response = await getEmployeeNominees(data);
        const fetchedNominees = response.data.data;
        console.log(fetchedNominees, "Nominee Data Fetched");

        if (fetchedNominees && fetchedNominees.length > 0) {
          setNominees(
            fetchedNominees.map((nominee) => ({
              Id: nominee.Id || "",
              NomineeName: nominee.NomineeName || "",
              NomineeAge: nominee.NomineeAge || "",
              NomineeAadhar: nominee.NomineeAadhar || "",
              Relationship: nominee.Relationship || "",
              OtherRelationship: nominee.OtherRelationship || "",
              NomiNeeAddress: nominee.NomineeAddress || "",
              Percentage: nominee.Percentage || "",
              EmpId: EmpId,
              UserId: UID,
            }))
          );
        } else {
          setNominees([
            {
              Id: "",
              NomineeName: "",
              NomineeAge: "",
              NomineeAadhar: "",
              Relationship: "",
              OtherRelationship: "",
              NomiNeeAddress: "",
              Percentage: "",
              EmpId: EmpId,
              UserId: UID,
            },
          ]);
        }
      } catch (error) {
        console.error("Error fetching nominees:", error);
        toast.error("Failed to fetch nominee details.");
      }
    };

    if (EmpId && UID) {
      fetchNominees();
    }
  }, [EmpId, UID]);

  const validateInput = (name, value) => {
    let error = "";
    if (name === "NomineeAadhar" && value.length !== 12) {
      error = "Aadhar number must be exactly 12 digits.";
    }
    if (
      [
        "NomineeName",
        "NomineeAge",
        "NomineeAadhar",
        "Relationship",
        "NomiNeeAddress",
        "Percentage",
      ].includes(name) &&
      !value
    ) {
      error = `${name} is required.`;
    }
    if (name === "Percentage") {
      const numValue = parseFloat(value);
      if (numValue <= 0 || numValue > 100) {
        error = "Percentage must be between 1 and 100.";
      }
    }
    return error;
  };

  // // Validate total percentage of nominees
  // const validateTotalPercentage = () => {
  //   const totalPercentage = nominees.reduce(
  //     (sum, nominee) => sum + (parseFloat(nominee.Percentage) || 0),
  //     0
  //   );
  //   if (totalPercentage !== 100) {
  //     setPercentageError("Total nominee percentage must equal 100.");
  //     return false;
  //   }
  //   setPercentageError("");
  //   return true;
  // };

  const addNominee = () => {
    setNominees((prev) => [
      ...prev,
      {
        Id: "",
        NomineeName: "",
        NomineeAge: "",
        NomineeAadhar: "",
        Relationship: "",
        OtherRelationship: "",
        NomiNeeAddress: "",
        Percentage: "",
        EmpId: EmpId,
        UserId: UID,
      },
    ]);
  };


  const removeNominee = async (Id, index) => {
    console.log("Removing nominee with Id:", Id, "at index:", index);

    if (Id) {
      // Backend removal for existing nominee
      try {
        const data = { UserId: UID, Id: Id };
        const response = await RemoveNominee(data);
        if (response.status === 200) {
          toast.success("Nominee removed successfully.");
          // Fetch updated nominees and update state
          const updatedNomineesResponse = await getEmployeeNominees({ EmpId, UserId: UID });
          const fetchedNominees = updatedNomineesResponse.data.data || [];
          setNominees(
            fetchedNominees.length > 0
              ? fetchedNominees.map((nominee) => ({
                Id: nominee.Id || "",
                NomineeName: nominee.NomineeName || "",
                NomineeAge: nominee.NomineeAge || "",
                NomineeAadhar: nominee.NomineeAadhar || "",
                Relationship: nominee.Relationship || "",
                OtherRelationship: nominee.OtherRelationship || "",
                NomiNeeAddress: nominee.NomineeAddress || "",
                Percentage: nominee.Percentage || "",
                EmpId: EmpId,
                UserId: UID,
              }))
              : [
                {
                  Id: "",
                  NomineeName: "",
                  NomineeAge: "",
                  NomineeAadhar: "",
                  Relationship: "",
                  OtherRelationship: "",
                  NomiNeeAddress: "",
                  Percentage: "",
                  EmpId: EmpId,
                  UserId: UID,
                },
              ]
          );
        }
      } catch (error) {
        console.error("Error removing nominee:", error);
        toast.error("Failed to remove nominee: " + (error.response?.data?.message || error.message));
        setErrors((prev) => ({
          ...prev,
          removeNominee: "Failed to remove nominee",
        }));
      }
    } else {
      // Local state removal for unsaved nominee
      const updatedNominees = [...nominees];
      updatedNominees.splice(index, 1);
      setNominees(updatedNominees);
      toast.success("Nominee removed locally.");
    }
  };


  const ClearPersonalData = () => {
    setPersonalDetails({
      CurrentAddress: "",
      PermanentAddress: "",
      Experience: "",
      BloodGrp: "",
      PFNo: "",
      FatherorHus: "",
      Qualification: "",
      OtherQualification: "",
      UAN: "",
      PAN: "",
      Nationality: "",
      Religion: "",
      Caste: "",
      OtherCast: "",
      OtherReligion: "",
      UserId: UID,
      EmpId: EmpId,
    });
    setNominees([
      {
        Id: "",
        NomineeName: "",
        NomineeAge: "",
        NomineeAadhar: "",
        Relationship: "",
        OtherRelationship: "",
        NomiNeeAddress: "",
        Percentage: "",
        EmpId: EmpId,
        UserId: UID,
      },
    ]);
    setErrors({});
    setPercentageError("");
  };

  const casteOptions = {
    Hindu: ["General", "OBC", "SC", "ST", "Other"],
    Muslim: ["General", "OBC", "Other"],
    Christian: ["General", "Other"],
    Sikh: ["General", "Other"],
    Other: ["Other"],
  };

  const validateTotalPercentage = () => {
    const totalPercentage = nominees.reduce(
      (sum, nominee) => sum + (parseFloat(nominee.Percentage) || 0),
      0
    );
    if (totalPercentage !== 100) {
      setPercentageError("");
      return false;
    }
    setPercentageError("");
    return true;
  };


  const handlePersonalDetailsSubmit = async (e) => {
    e.preventDefault();
    if (!validateTotalPercentage()) {
      toast.error("Total nominee percentage must equal 100")
      return
    }
    setLoading(true);
    try {
      const personalResponse = await insertPerEmployee(personalDetails);
      if (personalResponse.data.StatusCode === 200) {
        toast.success(personalResponse.data.message);
        const nomineeResponse = await InsertNominibulk(nominees);
        console.log(nomineeResponse, 'yutuytyuyuytu');

        if (nomineeResponse) {
          toast.success("All nominees added successfully.");
          onClose();
        } else {
          toast.error("Failed to add nominees");
        }
      } else {
        toast.error("Failed to add personal details");
      }
    } catch (error) {
      const errorMessage =
        error.response?.data?.error ||
        error.message ||
        "An unexpected error occurred.";
      toast.error(
        errorMessage.includes("Duplicate Email")
          ? errorMessage
          : "Error occurred while adding details."
      );
      console.error("Error:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    setLoading(true);
    const getPersonal = async () => {
      try {
        const response = await GetEmployeedetails(UID);
        if (response?.data?.data) {
          const data = response.data.data.find((el) => el.EmployeeId === EmpId);
          setLoading(false);
          if (data) {
            setPersonalDetails({
              ...personalDetails,
              ...data,
              EmpId: EmpId,
              UserId: UID,
            });
            if (data.Nominees && data.Nominees.length > 0) {
              setNominees(
                data.Nominees.map((nominee) => ({
                  ...nominee,
                  EmpId: EmpId,
                  UserId: UID,
                }))
              );
            }
          } else {
            console.warn("No personal details found for the given employee ID.");
          }
        } else {
          console.warn("Response data is empty or undefined.");
        }
      } catch (error) {
        console.error("Error fetching personal details:", error);
        setLoading(false);
      }
    };
    getPersonal();
  }, [UID, EmpId]);

  if (loading) {
    return (
      <div className="skeleton-container">
        {[...Array(9)].map((_, rowIndex) => (
          <div
            className="skeleton-row"
            key={rowIndex}
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(2, 1fr)",
              gap: "1rem",
              marginBottom: "1rem",
            }}
          >
            <Skeleton height={50} width="100%" />
            <Skeleton height={50} width="100%" />
          </div>
        ))}
      </div>
    );
  }

  const handleIsEdit = () => {
    setIsEdit(!isEdit);
  };

  return (
    <div>
      <form onSubmit={handlePersonalDetailsSubmit}>
        <div className="my-10 md:px-10 px-[7px] max-h-[70vh] overflow-auto cus-scrollbar">
          <div className="flex justify-end">
            <button
              className="btn btn-success"
              type="button"
              onClick={handleIsEdit}
            >
              {isEdit ? "Enable Edit Mode" : "Disable Edit Mode"}
            </button>
          </div>
          <div className="grid grid-cols-12 gap-20">
            <div className="form-group col-span-6 mt-30">
              <label>
                Current Address <span style={{ color: "red" }}>*</span>
              </label>
              <textarea
                disabled={isEdit}
                name="CurrentAddress"
                value={personalDetails.CurrentAddress}
                onChange={handleInputChanges}
                placeholder="Current Address"
                className="w-full"
                required
              />
            </div>
            <div className="form-group col-span-6 mt-30">
              <div className="flex items-center w-full">
                <label className="flex items-center flex-row space-x-1">
                  <p>Permanent</p> <p>Address</p>
                  <span style={{ color: "red" }}>*</span>
                </label>
                <div className="flex flex-row ms-[30%] gap-2">
                  <input
                    type="checkbox"
                    disabled={isEdit}
                    id="sameAsCurrentAddress"
                    name="sameAsCurrentAddress"
                    onChange={(e) => {
                      setPersonalDetails((prev) => ({
                        ...prev,
                        PermanentAddress: e.target.checked
                          ? personalDetails.CurrentAddress
                          : "",
                      }));
                    }}
                    className="h-[17px]"
                  />
                  <label
                    htmlFor="sameAsCurrentAddress"
                    className="text-sm text-gray-600 flex flex-row space-x-1"
                  >
                    <p>Same</p> <p>as</p> <p>Current</p> <p>Address</p>
                  </label>
                </div>
              </div>
              <textarea
                name="PermanentAddress"
                disabled={isEdit}
                value={personalDetails.PermanentAddress}
                onChange={handleInputChanges}
                placeholder="Permanent Address"
                className="w-full"
                required
              />
            </div>
            <div className="form-group col-span-6">
              <label>Experience (In Years)</label>
              <input
                disabled={isEdit}
                onWheel={(e) => e.target.blur()}

                type="number"
                name="Experience"
                value={personalDetails.Experience}
                onChange={handleInputChanges}
                placeholder="Experience"
              />
            </div>
            <div className="form-group col-span-6">
              <label>
                Qualification <span style={{ color: "red" }}>*</span>
              </label>
              <select
                disabled={isEdit}
                name="Qualification"
                value={personalDetails.Qualification}
                onChange={handleInputChanges}
                className="form-control"
                required
              >
                <option value="">Select Qualification</option>
                <option value="High School">High School</option>
                <option value="Diploma">Diploma</option>
                <option value="Bachelor's Degree">Bachelor's Degree</option>
                <option value="Master's Degree">Master's Degree</option>
                <option value="Ph.D">Ph.D</option>
                <option value="Other">Other</option>
              </select>
            </div>
            {personalDetails.Qualification === "Other" && (
              <div className="form-group col-span-6">
                <label>
                  Other Qualification <span style={{ color: "red" }}>*</span>
                </label>
                <input
                  disabled={isEdit}
                  type="text"
                  name="OtherQualification"
                  value={personalDetails.OtherQualification}
                  onChange={handleInputChanges}
                  placeholder="Other Qualification"
                  required
                />
              </div>
            )}
            <div className="form-group col-span-6">
              <label>Blood Group</label>
              <select
                disabled={isEdit}
                name="BloodGrp"
                value={personalDetails.BloodGrp}
                onChange={handleInputChanges}
                className="form-control"
              >
                <option value="">Select Blood Group</option>
                <option value="A+">A+</option>
                <option value="A-">A-</option>
                <option value="B+">B+</option>
                <option value="B-">B-</option>
                <option value="O+">O+</option>
                <option value="O-">O-</option>
                <option value="AB+">AB+</option>
                <option value="AB-">AB-</option>
              </select>
            </div>
            <div className="form-group col-span-6">
              <label>PF Number</label>
              <input
                disabled={isEdit}
                type="number"
                onWheel={(e) => e.target.blur()}

                name="PFNo"
                value={personalDetails.PFNo}
                onChange={handleInputChanges}
                placeholder="Enter PF Number"
                className="form-control"
              />
            </div>
              <div className="form-group col-span-6">
              <label>PF Opening Amount</label>
              <input
                disabled={isEdit}
                type="number"
                onWheel={(e) => e.target.blur()}
                name="openingAmount"
                value={personalDetails.openingAmount}
                onChange={handleInputChanges}
                placeholder="Enter Opening Amount"
                className="form-control"
              />
            </div>
              <div className="form-group col-span-6">
              <label>
                PF Opening Date
              </label>
              <input
                disabled={isEdit == true}
                type="date"
                id="PfOpeningDate"
                name="PfOpeningDate"
                value={
                  personalDetails?.PfOpeningDate
                    ? new Date(personalDetails?.PfOpeningDate).toISOString().split("T")[0]
                    : ""
                }
                onChange={handleInputChanges}
                placeholder="Date of birth"
              />
            </div>
            <div className="form-group col-span-6">
              <label>Father/Husband's Name</label>
              <input
                disabled={isEdit}
                type="text"
                name="FatherorHus"
                value={personalDetails.FatherorHus}
                onChange={handleInputChanges}
                placeholder="Enter Father's/Husband's Name"
                className="form-control"
              />
            </div>
            <div className="form-group col-span-6">
              <label>UAN</label>
              <input
                disabled={isEdit}
                type="text"
                name="UAN"
                value={personalDetails.UAN}
                onChange={handleInputChanges}
                placeholder="Enter UAN"
                className="form-control"
              />
            </div>

            <div className="form-group col-span-6">
              <label>
                Nationality <span style={{ color: "red" }}>*</span>
              </label>
              <select
                disabled={isEdit}
                name="Nationality"
                value={personalDetails.Nationality}
                onChange={handleInputChanges}
                className="form-control"
                required
              >
                <option value="">Select Nationality</option>
                <option value="Indian">Indian</option>
                <option value="Other">Other</option>
              </select>
            </div>
            <div className="form-group col-span-6">
              <label htmlFor="religion">Religion</label>
              <select
                disabled={isEdit}
                id="religion"
                name="Religion"
                value={personalDetails.Religion || ""}
                onChange={handleInputChanges}
                className="form-control"
              >
                <option value="">Select Religion</option>
                <option value="Hindu">Hindu</option>
                <option value="Muslim">Muslim</option>
                <option value="Christian">Christian</option>
                <option value="Sikh">Sikh</option>
                <option value="Other">Other</option>
              </select>
            </div>
            {personalDetails.Religion === "Other" ? (
              <>
                <div className="form-group col-span-6">
                  <label htmlFor="otherReligion">
                    Enter Other Religion <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    disabled={isEdit}
                    id="otherReligion"
                    type="text"
                    name="OtherReligion"
                    value={personalDetails.OtherReligion || ""}
                    onChange={handleInputChanges}
                    placeholder="Enter Other Religion"
                    className="form-control"
                    required
                    onBlur={(e) =>
                      handleInputChanges({
                        target: { name: "OtherReligion", value: e.target.value.trim() },
                      })
                    }
                  />
                </div>
                <div className="form-group col-span-6">
                  <label htmlFor="otherCast">
                    Enter Caste <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    disabled={isEdit}
                    id="otherCast"
                    type="text"
                    name="OtherCast"
                    value={personalDetails.OtherCast || ""}
                    onChange={handleInputChanges}
                    placeholder="Enter Caste"
                    className="form-control"
                    required
                    onBlur={(e) =>
                      handleInputChanges({
                        target: { name: "OtherCast", value: e.target.value.trim() },
                      })
                    }
                  />
                </div>
              </>
            ) : (
              personalDetails.Religion && (
                <>
                  <div className="form-group col-span-6">
                    <label htmlFor="caste">Caste</label>
                    <select
                      disabled={isEdit}
                      id="caste"
                      name="Caste"
                      value={personalDetails.Caste || ""}
                      onChange={handleInputChanges}
                      className="form-control"
                    >
                      <option value="">Select Caste</option>
                      {casteOptions[personalDetails.Religion]?.map((caste) => (
                        <option key={caste} value={caste}>
                          {caste}
                        </option>
                      ))}
                    </select>
                  </div>
                  {personalDetails.Caste === "Other" && (
                    <div className="form-group col-span-6">
                      <label htmlFor="otherCast">
                        Enter Caste <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        disabled={isEdit}
                        id="otherCast"
                        type="text"
                        name="OtherCast"
                        value={personalDetails.OtherCast || ""}
                        onChange={handleInputChanges}
                        placeholder="Enter Caste"
                        className="form-control"
                        required
                        onBlur={(e) =>
                          handleInputChanges({
                            target: { name: "OtherCast", value: e.target.value.trim() },
                          })
                        }
                      />
                    </div>
                  )}
                </>
              )
            )}
            <div className="col-span-12">
              <h3 className="text-lg font-semibold mt-4 mb-2">Nominee Details</h3>
              {percentageError && (
                <p className="text-red-500 mb-2">{percentageError}</p>
              )}
              {nominees.map((nominee, index) => (
                <div key={index} className="border p-4 mb-4 rounded">
                  <div className="flex justify-between items-center mb-2">
                    <h4>Nominee {index + 1}</h4>
                    {nominees.length > 1 && (
                      <button
                        type="button"
                        className="btn btn-danger text-sm"
                        onClick={() => removeNominee(nominee.Id, index)} // ✅ fixed here
                        disabled={isEdit}
                      >
                        Remove
                      </button>
                    )}

                  </div>
                  <div className="grid grid-cols-12 gap-4">
                    <div className="form-group col-span-6">
                      <label>
                        Nominee Name <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        disabled={isEdit}
                        type="text"
                        name="NomineeName"
                        value={nominee.NomineeName}
                        onChange={(e) => handleInputChanges(e, index)}
                        placeholder="Enter Nominee Name"
                        className={`form-control ${errors[`NomineeName_${index}`] ? "border-red-500" : ""
                          }`}
                        required
                      />
                      {errors[`NomineeName_${index}`] && (
                        <p className="text-red-500 mt-1">
                          {errors[`NomineeName_${index}`]}
                        </p>
                      )}
                    </div>
                    <div className="form-group col-span-6">
                      <label>
                        Nominee Percentage <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        disabled={isEdit}
                        type="number"
                        onWheel={(e) => e.target.blur()}

                        name="Percentage"
                        value={nominee.Percentage}
                        onChange={(e) => handleInputChanges(e, index)}
                        placeholder="Enter Nominee Percentage"
                        className={`form-control ${errors[`Percentage_${index}`] ? "border-red-500" : ""
                          }`}
                        required
                      />
                      {errors[`Percentage_${index}`] && (
                        <p className="text-red-500 mt-1">
                          {errors[`Percentage_${index}`]}
                        </p>
                      )}
                    </div>
                    <div className="form-group col-span-6">
                      <label>
                        Nominee Age <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        disabled={isEdit}
                        type="number"
                        name="NomineeAge"
                        onWheel={(e) => e.target.blur()}

                        value={nominee.NomineeAge}
                        onChange={(e) => handleInputChanges(e, index)}
                        placeholder="Enter Nominee Age"
                        min="0"
                        max="120"
                        className={`form-control ${errors[`NomineeAge_${index}`] ? "border-red-500" : ""
                          }`}
                        required
                      />
                      {errors[`NomineeAge_${index}`] && (
                        <p className="text-red-500 mt-1">
                          {errors[`NomineeAge_${index}`]}
                        </p>
                      )}
                    </div>
                    <div className="form-group col-span-6">
                      <label>
                        Nominee Aadhar No <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        disabled={isEdit}
                        type="number"
                        name="NomineeAadhar"
                        value={nominee.NomineeAadhar}
                        onChange={(e) => handleInputChanges(e, index)}
                        onInput={(e) => {
                          if (e.target.value.length > 12)
                            e.target.value = e.target.value.slice(0, 12);
                        }}
                        placeholder="Enter Nominee Aadhar No"
                        className={`w-full p-2 border rounded ${errors[`NomineeAadhar_${index}`] ? "border-red-500" : ""
                          }`}
                        required
                      />
                      {errors[`NomineeAadhar_${index}`] && (
                        <p className="text-red-500 mt-1">
                          {errors[`NomineeAadhar_${index}`]}
                        </p>
                      )}
                    </div>
                    <div className="form-group col-span-6">
                      <label>
                        Nominee Relationship <span style={{ color: "red" }}>*</span>
                      </label>
                      <select
                        disabled={isEdit}
                        name="Relationship"
                        value={nominee.Relationship || ""}
                        onChange={(e) => handleInputChanges(e, index)}
                        className={`form-control ${errors[`Relationship_${index}`] ? "border-red-500" : ""
                          }`}
                        required
                      >
                        <option value="">Select Relationship</option>
                        <option value="Father">Father</option>
                        <option value="Mother">Mother</option>
                        <option value="Other">Other</option>
                      </select>
                      {errors[`Relationship_${index}`] && (
                        <p className="text-red-500 mt-1">
                          {errors[`Relationship_${index}`]}
                        </p>
                      )}
                    </div>
                    {nominee.Relationship === "Other" && (
                      <div className="form-group col-span-6">
                        <label>
                          Enter Other Relationship <span style={{ color: "red" }}>*</span>
                        </label>
                        <input
                          disabled={isEdit}
                          type="text"
                          name="OtherRelationship"
                          value={nominee.OtherRelationship || ""}
                          onChange={(e) => handleInputChanges(e, index)}
                          placeholder="Enter Relationship"
                          className={`form-control ${errors[`OtherRelationship_${index}`] ? "border-red-500" : ""
                            }`}
                          required
                        />
                        {errors[`OtherRelationship_${index}`] && (
                          <p className="text-red-500 mt-1">
                            {errors[`OtherRelationship_${index}`]}
                          </p>
                        )}
                      </div>
                    )}
                    <div className="form-group col-span-6">
                      <div className="flex items-center w-full">
                        <label className="flex items-center flex-row space-x-1">
                          <p>Nominee</p> <p>Address</p>
                          <span style={{ color: "red" }}>*</span>
                        </label>
                        <div className="flex flex-row ms-[30%] gap-2">
                          <input
                            disabled={isEdit}
                            type="checkbox"
                            id={`sameAsCurrentAddressNominee_${index}`}
                            name="sameAsCurrentAddressNominee"
                            onChange={(e) => {
                              setNominees((prev) => {
                                const updatedNominees = [...prev];
                                updatedNominees[index] = {
                                  ...updatedNominees[index],
                                  NomiNeeAddress: e.target.checked
                                    ? personalDetails.CurrentAddress
                                    : "",
                                };
                                return updatedNominees;
                              });
                            }}
                            className="h-[25px]"
                          />
                          <label
                            htmlFor={`sameAsCurrentAddressNominee_${index}`}
                            className="text-sm text-gray-600 flex flex-row space-x-1"
                          >
                            <p>Same</p> <p>as</p> <p>Current</p> <p>Address</p>
                          </label>
                        </div>
                      </div>
                      <textarea
                        disabled={isEdit}
                        name="NomiNeeAddress"
                        value={nominee.NomiNeeAddress}
                        onChange={(e) => handleInputChanges(e, index)}
                        placeholder="Enter Nominee's Address"
                        className={`w-full ${errors[`NomiNeeAddress_${index}`] ? "border-red-500" : ""
                          }`}
                        required
                      />
                      {errors[`NomiNeeAddress_${index}`] && (
                        <p className="text-red-500 mt-1">
                          {errors[`NomiNeeAddress_${index}`]}
                        </p>
                      )}
                    </div>
                  </div>
                </div>
              ))}
              <div className="col-span-12">
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={addNominee}
                  disabled={isEdit}
                >
                  Add Nominee
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="md:px-10 px-[7px] flex gap-10 justify-end py-10">
          <button
            type="button"
            onClick={ClearPersonalData}
            className="btn btn-outline-secondary"
          >
            Clear
          </button>
          <button
            type="submit"
            className="btn btn-primary"
            disabled={loading || isEdit || Object.values(errors).some((err) => err) || percentageError}
          >
            Submit
          </button>
        </div>
      </form>
    </div>
  );
}

export default PersonalDetails;